import { enable, disable, auto } from 'darkreader'
import {
  DARK_MODE_AUTO,
  DARK_MODE_LIGHT,
  DARK_MODE_DARK
} from '@/lib/constants'

const darkModeOptions = {
  brightness: 125,
  contrast: 108,
  sepia: -25,
  darkSchemeTextColor: '#fff',
  styleSystemControls: false
}

export function enableDarkMode() {
  enable(darkModeOptions)
}

export function disableDarkMode() {
  disable()
}

export function followSystemColorScheme() {
  auto(darkModeOptions)
}

export function toggleDarkMode(mode) {
  if (mode === DARK_MODE_AUTO) {
    followSystemColorScheme()
  } else if (mode === DARK_MODE_LIGHT) {
    disableDarkMode()
  } else if (mode === DARK_MODE_DARK) {
    enableDarkMode()
  }
}
